export default __webpack_public_path__ + "static/media/slide6.695cfc43.jpg";